import React, {useState} from 'react';
import {PageContainer} from "../../components/pageContainer/PageContainer";
import {useTranslation} from "react-i18next";
import { PanelRow } from '../../components/panel/PanelRow';
import {Panel} from "../../components/panel/Panel";
import styles from './Renewal.module.scss';
import {Text} from "../../components/text/Text";
import moment from "moment";
import {useAuthSelector} from "../auth/authSlice";
import {Button} from "../../components/button/Button";
import {navilineService} from "../../services/navilineService";
import {useHistory} from "react-router-dom";
import {navilinePaymentTypes} from "../../constants";

export const BusinessLicenseRenewal = () => {
    const { t } = useTranslation();
    const history = useHistory();
    const [year, setYear] = useState(moment().subtract(1, 'years').year());
    const [accountNumber, setAccountNumber] = useState<string>('');
    const [pin, setPin] = useState('');
    const { isAuthenticated } = useAuthSelector(s => s);

    const goToPayment = async () => {
        if (!year || !accountNumber || !pin) {
            alert('BusinessLicense.Required');
            return;
        }

        const response = await navilineService.getBusinessLicenseFeesDue(year.toString(), accountNumber, pin);
        if (!response) {
            alert('Something went wrong!');
            return;
        }

        if (!response.success) {
            alert(response.message);
        } else if (response.fees! && response.fees! < 1) {
            alert('BusinessLicense.NoFees');
        } else {
            // navigate the user to the payment screen with the amount due
            history.push(`/payment?accountYear=${year.toString().slice(-2)}&accountNumber=${year.toString().slice(-2)}-${accountNumber}&accountType=${navilinePaymentTypes.businessLicenseRenewal}&amount=${response.fees!}&penaltyAmount=${response.penalty!}`);
        }
    }

    return (
        <PageContainer style={isAuthenticated ? {} : { maxWidth: 700, width: '100%'}}>
            <div className='headerContainer'>
                <h1>{t('Activity.PAY_FOR_LICENSE_RENEWAL')}</h1>
            </div>
            <PanelRow>
                <Panel>
                    <p>{t('BusinessLicense.Instructions')}</p>
                    <div className={styles.row}>
                        <label htmlFor="license-year" className={styles.inputLabel}>{t('BusinessLicense.Year')}</label>
                        <Text id="license-year"
                              value={year}
                              fluid={false}
                              step={1}
                              min={2020}
                              type={'number'}
                              required
                              aria-label={t('BusinessLicense.Year')}
                              onChange={(event: any, data: any) => setYear(data.value)} />
                    </div>
                    <div className={styles.row}>
                        <label htmlFor="license-account" className={styles.inputLabel}>{t('BusinessLicense.AccountNumber')}</label>
                        <Text id="license-account"
                              value={accountNumber}
                              fluid={false}
                              required
                              aria-label={t('BusinessLicense.AccountNumber')}
                              onChange={(event: any, data: any) => setAccountNumber(data.value)} />
                    </div>
                    <div className={styles.row}>
                        <label htmlFor="license-pin" className={styles.inputLabel}>{t('BusinessLicense.PIN')}</label>
                        <Text id="license-pin"
                              value={pin}
                              fluid={false}
                              required
                              aria-label={t('BusinessLicense.PIN')}
                              onChange={(event: any, data: any) => setPin(data.value)} />
                    </div>
                    <div className={styles.row}>
                        <Button onClick={goToPayment} color={'blue'}>Continue</Button>
                    </div>
                </Panel>
            </PanelRow>
        </PageContainer>
    )
};
